module.exports = __webpack_public_path__ + "static/media/C-7ths.bc43c3af.png";